const lang = {
    "月历": {
        "zh_TW": "月曆",
        "en_US": "calendar",
        "vi_VN": "lịch"
    },
    "移至上个月": {
        "zh_TW": "移至上個月",
        "en_US": "move to previous month",
        "vi_VN": "chuyển sang tháng trước"
    },
    "年": {
        "zh_TW": "年",
        "en_US": "Year",
        "vi_VN": "Năm"
    },
    "月": {
        "zh_TW": "月",
        "en_US": "moon",
        "vi_VN": "mặt trăng"
    },
    "移至下个月": {
        "zh_TW": "移至下個月",
        "en_US": "move to next month",
        "vi_VN": "chuyển sang tháng tới"
    },
    "星期日": {
        "zh_TW": "星期日",
        "en_US": "Sunday",
        "vi_VN": "Chủ nhật"
    },
    "星期一": {
        "zh_TW": "星期一",
        "en_US": "Monday",
        "vi_VN": "Thứ hai"
    },
    "星期二": {
        "zh_TW": "星期二",
        "en_US": "Tuesday",
        "vi_VN": "Thứ ba"
    },
    "星期三": {
        "zh_TW": "星期三",
        "en_US": "Wednesday",
        "vi_VN": "Thứ Tư"
    },
    "星期四": {
        "zh_TW": "星期四",
        "en_US": "Thursday",
        "vi_VN": "Thứ năm"
    },
    "星期五": {
        "zh_TW": "星期五",
        "en_US": "Friday",
        "vi_VN": "Thứ sáu"
    },
    "星期六": {
        "zh_TW": "星期六",
        "en_US": "Saturday",
        "vi_VN": "Thứ bảy"
    },
    "文章编辑": {
        "zh_TW": "文章編輯",
        "en_US": "article editor",
        "vi_VN": "biên tập bài viết"
    },
    "语言": {
        "zh_TW": "語言",
        "en_US": "language",
        "vi_VN": "ngôn ngữ"
    },
    "标题": {
        "zh_TW": "標題",
        "en_US": "title",
        "vi_VN": "tiêu đề"
    },
    "封面": {
        "zh_TW": "封面",
        "en_US": "the cover",
        "vi_VN": "trang bìa"
    },
    "选择文件": {
        "zh_TW": "選擇文件",
        "en_US": "Select a document",
        "vi_VN": "Chọn một tài liệu"
    },
    "内文": {
        "zh_TW": "內文",
        "en_US": "text",
        "vi_VN": "chữ"
    },
    "开始时间": {
        "zh_TW": "開始時間",
        "en_US": "Starting time",
        "vi_VN": "thời gian bắt đầu"
    },
    "结束时间": {
        "zh_TW": "結束時間",
        "en_US": "End Time",
        "vi_VN": "Thời gian kết thúc"
    },
    "前台显示": {
        "zh_TW": "前台顯示",
        "en_US": "Foreground display",
        "vi_VN": "hiển thị tiền cảnh"
    },
    "显示": {
        "zh_TW": "顯示",
        "en_US": "show",
        "vi_VN": "trình diễn"
    },
    "不显示": {
        "zh_TW": "不顯示",
        "en_US": "Do not show",
        "vi_VN": "không hiển thị"
    },
    "删除": {
        "zh_TW": "刪除",
        "en_US": "delete",
        "vi_VN": "xóa bỏ"
    },
    "储存": {
        "zh_TW": "儲存",
        "en_US": "store",
        "vi_VN": "cửa hàng"
    },
    "储存中": {
        "zh_TW": "儲存中",
        "en_US": "in storage",
        "vi_VN": "trong lưu trữ"
    },
    "横幅编辑": {
        "zh_TW": "橫幅編輯",
        "en_US": "banner edit",
        "vi_VN": "chỉnh sửa biểu ngữ"
    },
    "横幅": {
        "zh_TW": "橫幅",
        "en_US": "the banner",
        "vi_VN": "bảng hiệu"
    },
    "链接": {
        "zh_TW": "鏈接",
        "en_US": "Link",
        "vi_VN": "liên kết"
    },
    "排序": {
        "zh_TW": "排序",
        "en_US": "to sort",
        "vi_VN": "xắp xếp"
    },
    "发行时间": {
        "zh_TW": "發行時間",
        "en_US": "publish time",
        "vi_VN": "xuất bản thời gian"
    },
    "游戏编辑": {
        "zh_TW": "遊戲編輯",
        "en_US": "game editor",
        "vi_VN": "biên tập trò chơi"
    },
    "游戏名称": {
        "zh_TW": "遊戲名稱",
        "en_US": "game name",
        "vi_VN": "tên của trò chơi"
    },
    "游戏关闭": {
        "zh_TW": "遊戲關閉",
        "en_US": "game off",
        "vi_VN": "kết thúc trò chơi"
    },
    "开放": {
        "zh_TW": "開放",
        "en_US": "open",
        "vi_VN": "mở"
    },
    "关闭": {
        "zh_TW": "關閉",
        "en_US": "closure",
        "vi_VN": "Khép kín"
    },
    "锁仓挖矿": {
        "zh_TW": "鎖倉挖礦",
        "en_US": "Lock mining",
        "vi_VN": "Khóa khai thác"
    },
    "收益率": {
        "zh_TW": "收益率",
        "en_US": "rate of return",
        "vi_VN": "tỷ lệ lợi nhuận"
    },
    "请输入收益率": {
        "zh_TW": "請輸入收益率",
        "en_US": "Please enter the rate of return",
        "vi_VN": "Vui lòng nhập tỷ lệ hoàn vốn"
    },
    "锁仓周期": {
        "zh_TW": "鎖倉週期",
        "en_US": "Lockup period",
        "vi_VN": "Thời gian khóa"
    },
    "请输入锁仓周期": {
        "zh_TW": "請輸入鎖倉週期",
        "en_US": "Please enter the lock period",
        "vi_VN": "Vui lòng nhập thời gian khóa"
    },
    "最小买入金额": {
        "zh_TW": "最小買入金額",
        "en_US": "Minimum purchase amount",
        "vi_VN": "Số tiền mua tối thiểu"
    },
    "最大买入金额": {
        "zh_TW": "最大買入金額",
        "en_US": "Maximum purchase amount",
        "vi_VN": "Số tiền mua tối đa"
    },
    "买入限制": {
        "zh_TW": "買入限制",
        "en_US": "buy limit",
        "vi_VN": "giới hạn mua"
    },
    "余额大于": {
        "zh_TW": "餘額大於",
        "en_US": "balance greater than",
        "vi_VN": "số dư lớn hơn"
    },
    "可买入": {
        "zh_TW": "可買入",
        "en_US": "can buy",
        "vi_VN": "có thể mua"
    },
    "子帐号编辑": {
        "zh_TW": "子帳號編輯",
        "en_US": "Sub-account edit",
        "vi_VN": "chỉnh sửa tài khoản phụ"
    },
    "帐号": {
        "zh_TW": "帳號",
        "en_US": "account number",
        "vi_VN": "số tài khoản"
    },
    "请输入3至12英文数字组合": {
        "zh_TW": "請輸入3至12英文數字組合",
        "en_US": "Please enter a combination of 3 to 12 English numbers",
        "vi_VN": "Vui lòng nhập tổ hợp từ 3 đến 12 số tiếng Anh"
    },
    "密码": {
        "zh_TW": "密碼",
        "en_US": "password",
        "vi_VN": "mật khẩu"
    },
    "名称": {
        "zh_TW": "名稱",
        "en_US": "name",
        "vi_VN": "tên"
    },
    "备注": {
        "zh_TW": "備註",
        "en_US": "Remark",
        "vi_VN": "Nhận xét"
    },
    "代理编辑": {
        "zh_TW": "代理編輯",
        "en_US": "Acting editor",
        "vi_VN": "Quyền biên tập viên"
    },
    "银行资料": {
        "zh_TW": "銀行資料",
        "en_US": "Bank info",
        "vi_VN": "thông tin ngân hàng"
    },
    "钱包类型": {
        "zh_TW": "錢包類型",
        "en_US": "wallet type",
        "vi_VN": "loại ví"
    },
    "交易所钱包": {
        "zh_TW": "交易所錢包",
        "en_US": "exchange wallet",
        "vi_VN": "trao đổi ví"
    },
    "银行钱包": {
        "zh_TW": "銀行錢包",
        "en_US": "bank wallet",
        "vi_VN": "ví ngân hàng"
    },
    "交易所": {
        "zh_TW": "交易所",
        "en_US": "exchange",
        "vi_VN": "trao đổi"
    },
    "银行": {
        "zh_TW": "銀行",
        "en_US": "bank",
        "vi_VN": "ngân hàng"
    },
    "协议": {
        "zh_TW": "協議",
        "en_US": "protocol",
        "vi_VN": "giao thức"
    },
    "分行": {
        "zh_TW": "分行",
        "en_US": "the branch",
        "vi_VN": "các chi nhánh"
    },
    "钱包地址": {
        "zh_TW": "錢包地址",
        "en_US": "wallet address",
        "vi_VN": "địa chỉ ví"
    },
    "银行帐户": {
        "zh_TW": "銀行帳戶",
        "en_US": "Bank account",
        "vi_VN": "tài khoản ngân hàng"
    },
    "户名": {
        "zh_TW": "戶名",
        "en_US": "account name",
        "vi_VN": "tên tài khoản"
    },
    "存折薄图片": {
        "zh_TW": "存摺薄圖片",
        "en_US": "Passbook picture",
        "vi_VN": "ảnh sổ tiết kiệm"
    },
    "查看原图": {
        "zh_TW": "查看原圖",
        "en_US": "View original photo",
        "vi_VN": "Xem ảnh gốc"
    },
    "身份证图片": {
        "zh_TW": "身份證圖片",
        "en_US": "ID card picture",
        "vi_VN": "ảnh chứng minh thư"
    },
    "审核状态": {
        "zh_TW": "審核狀態",
        "en_US": "Approval Status",
        "vi_VN": "tình trạng chính"
    },
    "待审核": {
        "zh_TW": "待審核",
        "en_US": "to be reviewed",
        "vi_VN": "để được xem xét"
    },
    "已驳回": {
        "zh_TW": "已駁回",
        "en_US": "rejected",
        "vi_VN": "vật bị loại bỏ"
    },
    "审核通过": {
        "zh_TW": "審核通過",
        "en_US": "examination passed",
        "vi_VN": "kiểm tra thông qua"
    },
    "未送出": {
        "zh_TW": "未送出",
        "en_US": "not sent",
        "vi_VN": "chưa được gửi"
    },
    "审核备注": {
        "zh_TW": "審核備註",
        "en_US": "Review Notes",
        "vi_VN": "Đánh giá Ghi chú"
    },
    "更新时间": {
        "zh_TW": "更新時間",
        "en_US": "update time",
        "vi_VN": "cập nhật thời gian"
    },
    "移线编辑": {
        "zh_TW": "移線編輯",
        "en_US": "Line Editing",
        "vi_VN": "chỉnh sửa dòng"
    },
    "姓名": {
        "zh_TW": "姓名",
        "en_US": "Name",
        "vi_VN": "Tên"
    },
    "原上线": {
        "zh_TW": "原上線",
        "en_US": "Originally online",
        "vi_VN": "ban đầu trực tuyến"
    },
    "新上线": {
        "zh_TW": "新上線",
        "en_US": "new online",
        "vi_VN": "mới trực tuyến"
    },
    "请输入帐号": {
        "zh_TW": "請輸入帳號",
        "en_US": "please enter your account",
        "vi_VN": "vui lòng nhập tài khoản của bạn"
    },
    "变更": {
        "zh_TW": "變更",
        "en_US": "change",
        "vi_VN": "thay đổi"
    },
    "使用者设定": {
        "zh_TW": "使用者設定",
        "en_US": "user settings",
        "vi_VN": "thiết lập người dùng"
    },
    "客服网址": {
        "zh_TW": "客服網址",
        "en_US": "Customer service website",
        "vi_VN": "Trang web dịch vụ khách hàng"
    },
    "登入纪录": {
        "zh_TW": "登入紀錄",
        "en_US": "login history",
        "vi_VN": "lịch sử đăng nhập"
    },
    "时间": {
        "zh_TW": "時間",
        "en_US": "time",
        "vi_VN": "thời gian"
    },
    "位置": {
        "zh_TW": "位置",
        "en_US": "Location",
        "vi_VN": "Vị trí"
    },
    "登入结果": {
        "zh_TW": "登入結果",
        "en_US": "Login result",
        "vi_VN": "Kết quả đăng nhập"
    },
    "登入成功": {
        "zh_TW": "登入成功",
        "en_US": "sign in suceesfully",
        "vi_VN": "đăng nhập thành công"
    },
    "基本资料": {
        "zh_TW": "基本資料",
        "en_US": "basic information",
        "vi_VN": "thông tin cơ bản"
    },
    "请输入3至12英文或数字组合": {
        "zh_TW": "請輸入3至12英文或數字組合",
        "en_US": "Please enter 3 to 12 English or number combination",
        "vi_VN": "Vui lòng nhập từ 3 đến 12 tiếng Anh hoặc kết hợp số"
    },
    "电话": {
        "zh_TW": "電話",
        "en_US": "Telephone",
        "vi_VN": "Điện thoại"
    },
    "地址": {
        "zh_TW": "地址",
        "en_US": "address",
        "vi_VN": "Địa chỉ"
    },
    "联络方式": {
        "zh_TW": "聯絡方式",
        "en_US": "contact method",
        "vi_VN": "phương pháp liên hệ"
    },
    "电话验证": {
        "zh_TW": "電話驗證",
        "en_US": "phone verification",
        "vi_VN": "xác minh điện thoại"
    },
    "已验证": {
        "zh_TW": "已驗證",
        "en_US": "Verified",
        "vi_VN": "Đã xác minh"
    },
    "未验证": {
        "zh_TW": "未驗證",
        "en_US": "Unverified",
        "vi_VN": "chưa được xác minh"
    },
    "冻结": {
        "zh_TW": "凍結",
        "en_US": "freeze",
        "vi_VN": "đông cứng"
    },
    "已冻结": {
        "zh_TW": "已凍結",
        "en_US": "frozen",
        "vi_VN": "Đông cứng"
    },
    "子账号编辑": {
        "zh_TW": "子賬號編輯",
        "en_US": "Sub account edit",
        "vi_VN": "Chỉnh sửa tài khoản phụ"
    },
    "删除中": {
        "zh_TW": "刪除中",
        "en_US": "deleting",
        "vi_VN": "xóa"
    },
    "寄送私讯": {
        "zh_TW": "寄送私訊",
        "en_US": "send private message",
        "vi_VN": "gửi tin nhắn riêng tư"
    },
    "会员": {
        "zh_TW": "會員",
        "en_US": "member",
        "vi_VN": "thành viên"
    },
    "内容": {
        "zh_TW": "內容",
        "en_US": "content",
        "vi_VN": "nội dung"
    },
    "送出": {
        "zh_TW": "送出",
        "en_US": "send out",
        "vi_VN": "gửi đi"
    },
    "银行审核": {
        "zh_TW": "銀行審核",
        "en_US": "bank audit",
        "vi_VN": "kiểm toán ngân hàng"
    },
    "代理资讯": {
        "zh_TW": "代理資訊",
        "en_US": "Agent information",
        "vi_VN": "thông tin đại lý"
    },
    "会员资讯": {
        "zh_TW": "會員資訊",
        "en_US": "Member Information",
        "vi_VN": "Thông tin thành viên"
    },
    "银行帐号": {
        "zh_TW": "銀行帳號",
        "en_US": "Bank account",
        "vi_VN": "tài khoản ngân hàng"
    },
    "驳回": {
        "zh_TW": "駁回",
        "en_US": "turn down",
        "vi_VN": "từ chối"
    },
    "通过": {
        "zh_TW": "通過",
        "en_US": "pass",
        "vi_VN": "vượt qua"
    },
    "钱包纪录": {
        "zh_TW": "錢包紀錄",
        "en_US": "wallet records",
        "vi_VN": "hồ sơ ví"
    },
    "余额": {
        "zh_TW": "餘額",
        "en_US": "balance",
        "vi_VN": "THĂNG BẰNG"
    },
    "异动量": {
        "zh_TW": "異動量",
        "en_US": "Abnormal momentum",
        "vi_VN": "đà bất thường"
    },
    "原因": {
        "zh_TW": "原因",
        "en_US": "reason",
        "vi_VN": "lý do"
    },
    "储值": {
        "zh_TW": "儲值",
        "en_US": "stored value",
        "vi_VN": "giá trị được lưu trữ"
    },
    "提领": {
        "zh_TW": "提領",
        "en_US": "withdraw",
        "vi_VN": "rút"
    },
    "赠点": {
        "zh_TW": "贈點",
        "en_US": "gift points",
        "vi_VN": "điểm quà tặng"
    },
    "扣点": {
        "zh_TW": "扣點",
        "en_US": "deduction points",
        "vi_VN": "điểm trừ"
    },
    "异动纪录": {
        "zh_TW": "異動紀錄",
        "en_US": "transaction record",
        "vi_VN": "ghi lại giao dịch"
    },
    "显示中": {
        "zh_TW": "顯示中",
        "en_US": "show",
        "vi_VN": "trưng bày trung quốc"
    },
    "隐藏中": {
        "zh_TW": "隱藏中",
        "en_US": "hiding",
        "vi_VN": "trốn"
    },
    "内容列表": {
        "zh_TW": "內容列表",
        "en_US": "content list",
        "vi_VN": "danh sách nội dung"
    },
    "请输入回复内容": {
        "zh_TW": "請輸入回复內容",
        "en_US": "Please enter the reply content",
        "vi_VN": "Vui lòng nhập nội dung trả lời"
    },
    "回复": {
        "zh_TW": "回复",
        "en_US": "reply",
        "vi_VN": "hồi đáp"
    },
    "回复中": {
        "zh_TW": "回復中",
        "en_US": "replying",
        "vi_VN": "trả lời"
    },
    "异动编辑": {
        "zh_TW": "異動編輯",
        "en_US": "Change edit",
        "vi_VN": "Thay đổi chỉnh sửa"
    },
    "代理": {
        "zh_TW": "代理",
        "en_US": "acting",
        "vi_VN": "diễn xuất"
    },
    "昵称": {
        "zh_TW": "暱稱",
        "en_US": "Nick name",
        "vi_VN": "tên nick"
    },
    "建立时间": {
        "zh_TW": "建立時間",
        "en_US": "build time",
        "vi_VN": "xây dựng thời gian"
    },
    "金额": {
        "zh_TW": "金額",
        "en_US": "the amount",
        "vi_VN": "số tiền"
    },
    "来源": {
        "zh_TW": "來源",
        "en_US": "source",
        "vi_VN": "nguồn"
    },
    "目的": {
        "zh_TW": "目的",
        "en_US": "Purpose",
        "vi_VN": "Mục đích"
    },
    "状态": {
        "zh_TW": "狀態",
        "en_US": "state",
        "vi_VN": "tình trạng"
    },
    "隐藏": {
        "zh_TW": "隱藏",
        "en_US": "hide",
        "vi_VN": "trốn"
    },
    "操作人": {
        "zh_TW": "操作人",
        "en_US": "Operator",
        "vi_VN": "Nhà điều hành"
    },
    "最后修改": {
        "zh_TW": "最後修改",
        "en_US": "Last Review",
        "vi_VN": "Đánh giá cuối cùng"
    },
    "数量": {
        "zh_TW": "數量",
        "en_US": "quantity",
        "vi_VN": "Số lượng"
    },
    "百分比手续费": {
        "zh_TW": "百分比手續費",
        "en_US": "Percentage Fee",
        "vi_VN": "Phí phần trăm"
    },
    "固定手续费": {
        "zh_TW": "固定手續費",
        "en_US": "Fixed Fee",
        "vi_VN": "Phí cố định"
    },
    "实际可得": {
        "zh_TW": "實際可得",
        "en_US": "actually available",
        "vi_VN": "thực sự có sẵn"
    },
    "提交时间": {
        "zh_TW": "提交時間",
        "en_US": "submission time",
        "vi_VN": "thời gian nộp"
    },
    "取消提领": {
        "zh_TW": "取消提領",
        "en_US": "cancel withdrawal",
        "vi_VN": "hủy rút tiền"
    },
    "确认送出": {
        "zh_TW": "確認送出",
        "en_US": "Confirm send",
        "vi_VN": "xác nhận gửi"
    },
    "您好，有": {
        "zh_TW": "您好，有",
        "en_US": "hello, yes",
        "vi_VN": "xin chào, vâng"
    },
    "笔提领信息待处理": {
        "zh_TW": "筆提領信息待處理",
        "en_US": "Pen withdrawal information is pending",
        "vi_VN": "Thông tin rút bút đang chờ xử lý"
    },
    "后台": {
        "zh_TW": "後台",
        "en_US": "Backstage",
        "vi_VN": "hậu trường"
    },
    "密码修改": {
        "zh_TW": "密碼修改",
        "en_US": "change Password",
        "vi_VN": "đổi mật khẩu"
    },
    "登出": {
        "zh_TW": "登出",
        "en_US": "Sign out",
        "vi_VN": "Đăng xuất"
    },
    "修改密码": {
        "zh_TW": "修改密碼",
        "en_US": "change Password",
        "vi_VN": "đổi mật khẩu"
    },
    "请输入3至12码英文或数字": {
        "zh_TW": "請輸入3至12碼英文或數字",
        "en_US": "Please enter 3 to 12 codes in English or numbers",
        "vi_VN": "Vui lòng nhập từ 3 đến 12 mã bằng tiếng Anh hoặc số"
    },
    "确认密码": {
        "zh_TW": "確認密碼",
        "en_US": "Confirm Password",
        "vi_VN": "Xác nhận mật khẩu"
    },
    "请在此输入密码": {
        "zh_TW": "請在此輸入密碼",
        "en_US": "Please enter your password here",
        "vi_VN": "Vui lòng nhập mật khẩu của bạn ở đây"
    },
    "活动纪录": {
        "zh_TW": "活動紀錄",
        "en_US": "Activity record",
        "vi_VN": "Bản ghi hoạt động"
    },
    "输入": {
        "zh_TW": "輸入",
        "en_US": "enter",
        "vi_VN": "đi vào"
    },
    "会员帐号": {
        "zh_TW": "會員帳號",
        "en_US": "Member Account",
        "vi_VN": "Tài khoản thành viên"
    },
    "查询": {
        "zh_TW": "查詢",
        "en_US": "Inquire",
        "vi_VN": "Hỏi thăm"
    },
    "活动标题": {
        "zh_TW": "活動標題",
        "en_US": "event title",
        "vi_VN": "tiêu đề sự kiện"
    },
    "核销时间": {
        "zh_TW": "核銷時間",
        "en_US": "Write-off time",
        "vi_VN": "thời gian xóa sổ"
    },
    "操作": {
        "zh_TW": "操作",
        "en_US": "operate",
        "vi_VN": "vận hành"
    },
    "核销中": {
        "zh_TW": "核銷中",
        "en_US": "Writing off",
        "vi_VN": "Viết tắt"
    },
    "核销": {
        "zh_TW": "核銷",
        "en_US": "write off",
        "vi_VN": "viết tắt"
    },
    "活动列表": {
        "zh_TW": "活動列表",
        "en_US": "Events List",
        "vi_VN": "Danh sách sự kiện"
    },
    "有效时间": {
        "zh_TW": "有效時間",
        "en_US": "Effective time",
        "vi_VN": "Thời gian hiệu quả"
    },
    "前台展示": {
        "zh_TW": "前台展示",
        "en_US": "Front display",
        "vi_VN": "Màn hình phía trước"
    },
    "修改时间": {
        "zh_TW": "修改時間",
        "en_US": "Change the time",
        "vi_VN": "Thay đổi thời gian"
    },
    "新增": {
        "zh_TW": "新增",
        "en_US": "add",
        "vi_VN": "Thêm vào"
    },
    "编辑": {
        "zh_TW": "編輯",
        "en_US": "edit",
        "vi_VN": "biên tập"
    },
    "横幅管理": {
        "zh_TW": "橫幅管理",
        "en_US": "banner config",
        "vi_VN": "danh sách biểu ngữ"
    },
    "横幅列表": {
        "zh_TW": "橫幅列表",
        "en_US": "banner list",
        "vi_VN": "danh sách biểu ngữ"
    },
    "图片": {
        "zh_TW": "圖片",
        "en_US": "picture",
        "vi_VN": "hình ảnh"
    },
    "消息列表": {
        "zh_TW": "消息列表",
        "en_US": "message list",
        "vi_VN": "danh sách tin nhắn"
    },
    "系统设定": {
        "zh_TW": "系統設定",
        "en_US": "system program",
        "vi_VN": "chương trình hệ thống"
    },
    "投注金额": {
        "zh_TW": "投注金額",
        "en_US": "bet amount",
        "vi_VN": "số tiền đặt cược"
    },
    "最低投注": {
        "zh_TW": "最低投注",
        "en_US": "minimum bet",
        "vi_VN": "đặt cược tối thiểu"
    },
    "最高投注": {
        "zh_TW": "最高投注",
        "en_US": "Highest bet",
        "vi_VN": "Đặt cược cao nhất"
    },
    "开放玩法": {
        "zh_TW": "開放玩法",
        "en_US": "open play",
        "vi_VN": "chơi mở"
    },
    "涨": {
        "zh_TW": "漲",
        "en_US": "rise",
        "vi_VN": "tăng lên"
    },
    "跌": {
        "zh_TW": "跌",
        "en_US": "fall",
        "vi_VN": "ngã"
    },
    "高": {
        "zh_TW": "高",
        "en_US": "high",
        "vi_VN": "cao"
    },
    "低": {
        "zh_TW": "低",
        "en_US": "Low",
        "vi_VN": "Thấp"
    },
    "单": {
        "zh_TW": "單",
        "en_US": "one",
        "vi_VN": "một"
    },
    "双": {
        "zh_TW": "雙",
        "en_US": "pair",
        "vi_VN": "đôi"
    },
    "赔率": {
        "zh_TW": "賠率",
        "en_US": "odds",
        "vi_VN": "tỷ lệ cược"
    },
    "游戏列表": {
        "zh_TW": "遊戲列表",
        "en_US": "game list",
        "vi_VN": "danh sách trò chơi"
    },
    "前往控端": {
        "zh_TW": "前往控端",
        "en_US": "Go to console",
        "vi_VN": "Chuyển đến bảng điều khiển"
    },
    "立即更新": {
        "zh_TW": "立即更新",
        "en_US": "update immediately",
        "vi_VN": "cập nhật ngay lập tức"
    },
    "倒数": {
        "zh_TW": "倒數",
        "en_US": "reciprocal",
        "vi_VN": "đối ứng"
    },
    "秒更新": {
        "zh_TW": "秒更新",
        "en_US": "update in seconds",
        "vi_VN": "cập nhật trong vài giây"
    },
    "编号": {
        "zh_TW": "編號",
        "en_US": "serial number",
        "vi_VN": "số seri"
    },
    "游戏": {
        "zh_TW": "遊戲",
        "en_US": "game",
        "vi_VN": "trò chơi"
    },
    "玩法": {
        "zh_TW": "玩法",
        "en_US": "how to play",
        "vi_VN": "cách chơi"
    },
    "期数": {
        "zh_TW": "期數",
        "en_US": "Period",
        "vi_VN": "Giai đoạn"
    },
    "投注内容": {
        "zh_TW": "投注內容",
        "en_US": "betting content",
        "vi_VN": "nội dung cá cược"
    },
    "开奖结果": {
        "zh_TW": "開獎結果",
        "en_US": "lottery results",
        "vi_VN": "kết quả xổ số"
    },
    "投注": {
        "zh_TW": "投注",
        "en_US": "betting",
        "vi_VN": "cá cược"
    },
    "有效投注": {
        "zh_TW": "有效投注",
        "en_US": "valid bet",
        "vi_VN": "đặt cược hợp lệ"
    },
    "输赢": {
        "zh_TW": "輸贏",
        "en_US": "win or lose",
        "vi_VN": "thắng hay thua"
    },
    "结果": {
        "zh_TW": "結果",
        "en_US": "result",
        "vi_VN": "kết quả"
    },
    "点数": {
        "zh_TW": "點數",
        "en_US": "points",
        "vi_VN": "điểm"
    },
    "选择期权": {
        "zh_TW": "選擇期權",
        "en_US": "option option",
        "vi_VN": "tùy chọn tùy chọn"
    },
    "BOSS游戏": {
        "zh_TW": "BOSS遊戲",
        "en_US": "boss game",
        "vi_VN": "trò chơi ông chủ"
    },
    "未结算": {
        "zh_TW": "未結算",
        "en_US": "Unsettlement",
        "vi_VN": "bất ổn"
    },
    "已结算": {
        "zh_TW": "已結算",
        "en_US": "Settled",
        "vi_VN": "Định cư"
    },
    "保存": {
        "zh_TW": "保存",
        "en_US": "save",
        "vi_VN": "cứu"
    },
    "回合管理": {
        "zh_TW": "回合管理",
        "en_US": "turn management",
        "vi_VN": "quản lý lần lượt"
    },
    "当前回合": {
        "zh_TW": "當前回合",
        "en_US": "current round",
        "vi_VN": "vòng hiện tại"
    },
    "回合投注": {
        "zh_TW": "回合投注",
        "en_US": "round betting",
        "vi_VN": "cá cược tròn"
    },
    "投注编号": {
        "zh_TW": "投注編號",
        "en_US": "bet number",
        "vi_VN": "số cược"
    },
    "总投注": {
        "zh_TW": "總投注",
        "en_US": "total betting",
        "vi_VN": "tổng cược"
    },
    "总额": {
        "zh_TW": "總額",
        "en_US": "lump sum",
        "vi_VN": "một lần"
    },
    "本日输赢": {
        "zh_TW": "本日輸贏",
        "en_US": "win or lose today",
        "vi_VN": "thắng hay thua hôm nay"
    },
    "回合列表": {
        "zh_TW": "回合列表",
        "en_US": "round list",
        "vi_VN": "danh sách tròn"
    },
    "启动自动产生": {
        "zh_TW": "啟動自動產生",
        "en_US": "start automatic generation",
        "vi_VN": "bắt đầu tạo tự động"
    },
    "关闭自动产生": {
        "zh_TW": "關閉自動產生",
        "en_US": "turn off automatic generation",
        "vi_VN": "tắt tạo tự động"
    },
    "目前": {
        "zh_TW": "目前",
        "en_US": "at present",
        "vi_VN": "hiện tại"
    },
    "期別": {
        "zh_TW": "期別",
        "en_US": "period",
        "vi_VN": "Giai đoạn"
    },
    "起始日期": {
        "zh_TW": "起始日期",
        "en_US": "start date",
        "vi_VN": "ngày bắt đầu"
    },
    "起止日期": {
        "zh_TW": "起止日期",
        "en_US": "start date",
        "vi_VN": "ngày bắt đầu"
    },
    "搜寻": {
        "zh_TW": "搜尋",
        "en_US": "search",
        "vi_VN": "tìm kiếm"
    },
    "币对": {
        "zh_TW": "幣對",
        "en_US": "currency pair",
        "vi_VN": "cặp tiền tệ"
    },
    "期别": {
        "zh_TW": "期別",
        "en_US": "period",
        "vi_VN": "Giai đoạn"
    },
    "盘口": {
        "zh_TW": "盤口",
        "en_US": "Handicap",
        "vi_VN": "chấp"
    },
    "BOSS彩票": {
        "zh_TW": "BOSS彩票",
        "en_US": "BOSS Lottery",
        "vi_VN": "BOSS xổ số"
    },
    "买涨/做多": {
        "zh_TW": "買漲/做多",
        "en_US": "buy up / go long",
        "vi_VN": "mua lên / đi dài"
    },
    "买跌/做空": {
        "zh_TW": "買跌/做空",
        "en_US": "Buy Short/Short",
        "vi_VN": "Mua ngắn/bán"
    },
    "买高": {
        "zh_TW": "買高",
        "en_US": "buy high",
        "vi_VN": "mua cao"
    },
    "买低": {
        "zh_TW": "買低",
        "en_US": "buy low",
        "vi_VN": "mua thấp"
    },
    "买单": {
        "zh_TW": "買單",
        "en_US": "pay the bill",
        "vi_VN": "thanh toán hóa đơn"
    },
    "买双": {
        "zh_TW": "買雙",
        "en_US": "buy double",
        "vi_VN": "mua đôi"
    },
    "代理/会员帐号": {
        "zh_TW": "代理/會員帳號",
        "en_US": "Agent/Member Account",
        "vi_VN": "Đại lý/Tài khoản thành viên"
    },
    "中奖": {
        "zh_TW": "中獎",
        "en_US": "win the lottery",
        "vi_VN": "trúng số"
    },
    "代理统计": {
        "zh_TW": "代理統計",
        "en_US": "Proxy statistics",
        "vi_VN": "Thống kê proxy"
    },
    "下线": {
        "zh_TW": "下線",
        "en_US": "offline",
        "vi_VN": "ngoại tuyến"
    },
    "详细": {
        "zh_TW": "詳細",
        "en_US": "detailed",
        "vi_VN": "chi tiết"
    },
    "总计": {
        "zh_TW": "總計",
        "en_US": "total",
        "vi_VN": "tổng cộng"
    },
    "会员投注": {
        "zh_TW": "會員投注",
        "en_US": "member betting",
        "vi_VN": "cá cược thành viên"
    },
    "游戏设定": {
        "zh_TW": "遊戲設定",
        "en_US": "game settings",
        "vi_VN": "Thiết lập trò chơi"
    },
    "币对列表": {
        "zh_TW": "幣對列表",
        "en_US": "List of currency pairs",
        "vi_VN": "Danh sách các cặp tiền tệ"
    },
    "停止下注": {
        "zh_TW": "停止下注",
        "en_US": "stop betting",
        "vi_VN": "dừng cá cược"
    },
    "停止开关": {
        "zh_TW": "停止開關",
        "en_US": "kill switch",
        "vi_VN": "giết công tắc"
    },
    "所有会员": {
        "zh_TW": "所有會員",
        "en_US": "all members",
        "vi_VN": "tất cả thành viên"
    },
    "开启投注": {
        "zh_TW": "開啟投注",
        "en_US": "Start betting",
        "vi_VN": "bắt đầu cá cược"
    },
    "关闭投注": {
        "zh_TW": "關閉投注",
        "en_US": "close bet",
        "vi_VN": "đặt cược gần"
    },
    "弹跳讯息": {
        "zh_TW": "彈跳訊息",
        "en_US": "bounce message",
        "vi_VN": "tin nhắn bị trả lại"
    },
    "指定帐号": {
        "zh_TW": "指定帳號",
        "en_US": "designated account",
        "vi_VN": "tài khoản được chỉ định"
    },
    "用": {
        "zh_TW": "用",
        "en_US": "use",
        "vi_VN": "sử dụng"
    },
    "隔开": {
        "zh_TW": "隔開",
        "en_US": "separated",
        "vi_VN": "ly thân"
    },
    "更新": {
        "zh_TW": "更新",
        "en_US": "renew",
        "vi_VN": "thay mới"
    },
    "公司获利": {
        "zh_TW": "公司獲利",
        "en_US": "company profit",
        "vi_VN": "lợi nhuận công ty"
    },
    "本日获利": {
        "zh_TW": "本日獲利",
        "en_US": "profit today",
        "vi_VN": "lợi nhuận hôm nay"
    },
    "目标获利": {
        "zh_TW": "目標獲利",
        "en_US": "target profit",
        "vi_VN": "lợi nhuận mục tiêu"
    },
    "延迟下注": {
        "zh_TW": "延遲下注",
        "en_US": "delayed betting",
        "vi_VN": "cá cược bị trì hoãn"
    },
    "延后秒数": {
        "zh_TW": "延後秒數",
        "en_US": "Snooze seconds",
        "vi_VN": "Báo lại giây"
    },
    "功能": {
        "zh_TW": "功能",
        "en_US": "Function",
        "vi_VN": "Chức năng"
    },
    "帐号不能为空": {
        "zh_TW": "帳號不能為空",
        "en_US": "Account cannot be empty",
        "vi_VN": "Tài khoản không được để trống"
    },
    "时间不能为空": {
        "zh_TW": "時間不能為空",
        "en_US": "time cannot be empty",
        "vi_VN": "thời gian không thể để trống"
    },
    "帐号已存在": {
        "zh_TW": "帳號已存在",
        "en_US": "account already exists",
        "vi_VN": "tài khoản đã tồn tại"
    },
    "最低买入": {
        "zh_TW": "最低買入",
        "en_US": "minimum buy",
        "vi_VN": "mua tối thiểu"
    },
    "最高买入": {
        "zh_TW": "最高買入",
        "en_US": "highest buy",
        "vi_VN": "mua cao nhất"
    },
    "余额限制": {
        "zh_TW": "餘額限制",
        "en_US": "balance limit",
        "vi_VN": "giới hạn số dư"
    },
    "天": {
        "zh_TW": "天",
        "en_US": "sky",
        "vi_VN": "bầu trời"
    },
    "大于": {
        "zh_TW": "大於",
        "en_US": "more than the",
        "vi_VN": "nhiều hơn"
    },
    "锁仓订单": {
        "zh_TW": "鎖倉訂單",
        "en_US": "Lock order",
        "vi_VN": "Khóa lệnh"
    },
    "条件用空格隔开": {
        "zh_TW": "條件用空格隔開",
        "en_US": "conditions separated by spaces",
        "vi_VN": "các điều kiện cách nhau bởi dấu cách"
    },
    "订单编号": {
        "zh_TW": "訂單編號",
        "en_US": "order number",
        "vi_VN": "số thứ tự"
    },
    "锁仓金额": {
        "zh_TW": "鎖倉金額",
        "en_US": "Lockup amount",
        "vi_VN": "Số tiền khóa"
    },
    "已派发收益": {
        "zh_TW": "已派發收益",
        "en_US": "Distributed proceeds",
        "vi_VN": "tiền thu được phân phối"
    },
    "锁仓时间": {
        "zh_TW": "鎖倉時間",
        "en_US": "Lockup time",
        "vi_VN": "thời gian khóa"
    },
    "派发收益时间": {
        "zh_TW": "派發收益時間",
        "en_US": "Distribution time",
        "vi_VN": "thời gian phân phối"
    },
    "进行中": {
        "zh_TW": "進行中",
        "en_US": "in progress",
        "vi_VN": "trong tiến trình"
    },
    "已完成": {
        "zh_TW": "已完成",
        "en_US": "completed",
        "vi_VN": "hoàn thành"
    },
    "BOSS游戏列表": {
        "zh_TW": "BOSS遊戲列表",
        "en_US": "BOSS game list",
        "vi_VN": "Danh sách trò chơi BOSS"
    },
    "投注号码": {
        "zh_TW": "投注號碼",
        "en_US": "betting number",
        "vi_VN": "số cá cược"
    },
    "取消": {
        "zh_TW": "取消",
        "en_US": "Cancel",
        "vi_VN": "Hủy bỏ"
    },
    "玩法设定": {
        "zh_TW": "玩法設定",
        "en_US": "Game settings",
        "vi_VN": "Cài đặt trò chơi"
    },
    "最小投注金额": {
        "zh_TW": "最小投注金額",
        "en_US": "Minimum bet amount",
        "vi_VN": "Số tiền đặt cược tối thiểu"
    },
    "最大投注金额": {
        "zh_TW": "最大投注金額",
        "en_US": "Maximum bet amount",
        "vi_VN": "Số tiền đặt cược tối đa"
    },
    "玩法名称": {
        "zh_TW": "玩法名稱",
        "en_US": "Play name",
        "vi_VN": "chơi tên"
    },
    "最大投注注数": {
        "zh_TW": "最大投註註數",
        "en_US": "Maximum number of bets",
        "vi_VN": "Số lần đặt cược tối đa"
    },
    "总注数": {
        "zh_TW": "總注數",
        "en_US": "Total bets",
        "vi_VN": "Tổng cược"
    },
    "开启": {
        "zh_TW": "開啟",
        "en_US": "turn on",
        "vi_VN": "bật"
    },
    "弹跳信息": {
        "zh_TW": "彈跳信息",
        "en_US": "bounce information",
        "vi_VN": "thông tin bị trả lại"
    },
    "子账号列表": {
        "zh_TW": "子賬號列表",
        "en_US": "Sub account list",
        "vi_VN": "Danh sách tài khoản phụ"
    },
    "建立日期": {
        "zh_TW": "建立日期",
        "en_US": "Creation date",
        "vi_VN": "Ngày thành lập"
    },
    "代理列表": {
        "zh_TW": "代理列表",
        "en_US": "proxy list",
        "vi_VN": "danh sách proxy"
    },
    "设定": {
        "zh_TW": "設定",
        "en_US": "set up",
        "vi_VN": "cài đặt"
    },
    "会员搜寻": {
        "zh_TW": "會員搜尋",
        "en_US": "member search",
        "vi_VN": "tìm kiếm thành viên"
    },
    "会员列表": {
        "zh_TW": "會員列表",
        "en_US": "member list",
        "vi_VN": "danh sách thành viên"
    },
    "权限设定": {
        "zh_TW": "權限設定",
        "en_US": "permission setting",
        "vi_VN": "cài đặt quyền"
    },
    "子帐号": {
        "zh_TW": "子帳號",
        "en_US": "Subaccount",
        "vi_VN": "Tài khoản phụ"
    },
    "使用者名称": {
        "zh_TW": "使用者名稱",
        "en_US": "username",
        "vi_VN": "tên tài khoản"
    },
    "代理帐号": {
        "zh_TW": "代理帳號",
        "en_US": "Agent account",
        "vi_VN": "tài khoản đại lý"
    },
    "会员姓名": {
        "zh_TW": "會員姓名",
        "en_US": "Member's name",
        "vi_VN": "Tên thành viên"
    },
    "钱包": {
        "zh_TW": "錢包",
        "en_US": "wallet",
        "vi_VN": "cái ví"
    },
    "注册时间": {
        "zh_TW": "註冊時間",
        "en_US": "Registration time",
        "vi_VN": "Thời gian đăng ký"
    },
    "登入状态": {
        "zh_TW": "登入狀態",
        "en_US": "login status",
        "vi_VN": "trạng thái đăng nhập"
    },
    "资料": {
        "zh_TW": "資料",
        "en_US": "material",
        "vi_VN": "vật liệu"
    },
    "登入时间": {
        "zh_TW": "登入時間",
        "en_US": "login time",
        "vi_VN": "thời gian đăng nhập"
    },
    "强制登出": {
        "zh_TW": "強制登出",
        "en_US": "force logout",
        "vi_VN": "buộc đăng xuất"
    },
    "您确定要强制登出该会员吗?": {
        "zh_TW": "您確定要強制登出該會員嗎?",
        "en_US": "Are you sure you want to force logout this member?",
        "vi_VN": "Bạn có chắc chắn muốn buộc đăng xuất thành viên này?"
    },
    "会员帐号,用空格隔开": {
        "zh_TW": "會員帳號,用空格隔開",
        "en_US": "Member accounts, separated by spaces",
        "vi_VN": "Tài khoản thành viên, cách nhau bởi dấu cách"
    },
    "审核中": {
        "zh_TW": "審核中",
        "en_US": "under review",
        "vi_VN": "đang được xem xét"
    },
    "审核驳回": {
        "zh_TW": "審核駁回",
        "en_US": "Review rejected",
        "vi_VN": "Đánh giá bị từ chối"
    },
    "代理资料": {
        "zh_TW": "代理資料",
        "en_US": "Agent information",
        "vi_VN": "thông tin đại lý"
    },
    "会员资料": {
        "zh_TW": "會員資料",
        "en_US": "member profile",
        "vi_VN": "hồ sơ thành viên"
    },
    "帐户资料": {
        "zh_TW": "帳戶資料",
        "en_US": "account information",
        "vi_VN": "thông tin tài khoản"
    },
    "私讯列表": {
        "zh_TW": "私訊列表",
        "en_US": "private message list",
        "vi_VN": "danh sách tin nhắn riêng tư"
    },
    "未读": {
        "zh_TW": "未讀",
        "en_US": "unread",
        "vi_VN": "chưa đọc"
    },
    "已读": {
        "zh_TW": "已讀",
        "en_US": "Have read",
        "vi_VN": "Đã đọc"
    },
    "收到的私信": {
        "zh_TW": "收到的私信",
        "en_US": "private message received",
        "vi_VN": "tin nhắn riêng nhận được"
    },
    "对象": {
        "zh_TW": "對象",
        "en_US": "object",
        "vi_VN": "sự vật"
    },
    "查看": {
        "zh_TW": "查看",
        "en_US": "Check",
        "vi_VN": "Kiểm tra"
    },
    "寄出的私信": {
        "zh_TW": "寄出的私信",
        "en_US": "private message sent",
        "vi_VN": "tin nhắn riêng đã gửi"
    },
    "订单金额": {
        "zh_TW": "訂單金額",
        "en_US": "order amount",
        "vi_VN": "số lượng đơn đặt hàng"
    },
    "充值金额": {
        "zh_TW": "充值金額",
        "en_US": "Recharge amount",
        "vi_VN": "số tiền nạp"
    },
    "汇率": {
        "zh_TW": "匯率",
        "en_US": "exchange rate",
        "vi_VN": "tỷ giá"
    },
    "发起时间": {
        "zh_TW": "發起時間",
        "en_US": "the starting time",
        "vi_VN": "thời gian bắt đầu"
    },
    "到账时间": {
        "zh_TW": "到賬時間",
        "en_US": "Arrival time",
        "vi_VN": "Thời gian đến"
    },
    "美金": {
        "zh_TW": "美金",
        "en_US": "US dollars",
        "vi_VN": "Đô la Mỹ"
    },
    "待处理": {
        "zh_TW": "待處理",
        "en_US": "Pending",
        "vi_VN": "Chưa giải quyết"
    },
    "已到账": {
        "zh_TW": "已到賬",
        "en_US": "Has arrived",
        "vi_VN": "Đã đến"
    },
    "已拒绝": {
        "zh_TW": "已拒絕",
        "en_US": "rejected",
        "vi_VN": "vật bị loại bỏ"
    },
    "拒绝": {
        "zh_TW": "拒絕",
        "en_US": "reject",
        "vi_VN": "từ chối"
    },
    "金流类型": {
        "zh_TW": "金流類型",
        "en_US": "cash flow type",
        "vi_VN": "loại dòng tiền"
    },
    "金流名称": {
        "zh_TW": "金流名稱",
        "en_US": "Cash flow name",
        "vi_VN": "Tên dòng tiền"
    },
    "最低充值金额": {
        "zh_TW": "最低充值金額",
        "en_US": "Minimum recharge amount",
        "vi_VN": "Số tiền nạp tối thiểu"
    },
    "最大充值金额": {
        "zh_TW": "最大充值金額",
        "en_US": "Maximum recharge amount",
        "vi_VN": "Số tiền nạp tối đa"
    },
    "平台设定": {
        "zh_TW": "平台設定",
        "en_US": "platform setting",
        "vi_VN": "cài đặt nền tảng"
    },
    "平台名称": {
        "zh_TW": "平台名稱",
        "en_US": "platform name",
        "vi_VN": "Tên ga tàu"
    },
    "预设语言": {
        "zh_TW": "預設語言",
        "en_US": "default language",
        "vi_VN": "ngôn ngữ mặc định"
    },
    "二维码": {
        "zh_TW": "二維碼",
        "en_US": "QR code",
        "vi_VN": "mã QR"
    },
    "接入接口": {
        "zh_TW": "接入接口",
        "en_US": "access interface",
        "vi_VN": "giao diện truy cập"
    },
    "BOSS棋牌": {
        "zh_TW": "BOSS棋牌",
        "en_US": "BOSS Chess",
        "vi_VN": "BOSS Tướng"
    },
    "客服链接": {
        "zh_TW": "客服鏈接",
        "en_US": "Customer service link",
        "vi_VN": "Liên kết dịch vụ khách hàng"
    },
    "在线人数": {
        "zh_TW": "在線人數",
        "en_US": "online users",
        "vi_VN": "người dùng trực tuyến"
    },
    "页尾文字": {
        "zh_TW": "頁尾文字",
        "en_US": "footer text",
        "vi_VN": "văn bản chân trang"
    },
    "验证时机设定": {
        "zh_TW": "驗證時機設定",
        "en_US": "Verification Timing Settings",
        "vi_VN": "Cài đặt thời gian xác minh"
    },
    "需验证": {
        "zh_TW": "需驗證",
        "en_US": "verification required",
        "vi_VN": "yêu cầu xác minh"
    },
    "不需验证": {
        "zh_TW": "不需驗證",
        "en_US": "no verification required",
        "vi_VN": "không cần xác minh"
    },
    "银行验证审核": {
        "zh_TW": "銀行驗證審核",
        "en_US": "Bank Verification Review",
        "vi_VN": "Đánh giá xác minh ngân hàng"
    },
    "需审核": {
        "zh_TW": "需審核",
        "en_US": "Need to review",
        "vi_VN": "Cần xem lại"
    },
    "不需审核": {
        "zh_TW": "不需審核",
        "en_US": "no review required",
        "vi_VN": "không cần xem xét"
    },
    "提领设定": {
        "zh_TW": "提領設定",
        "en_US": "Withdrawal Settings",
        "vi_VN": "Cài đặt rút tiền"
    },
    "最大数量": {
        "zh_TW": "最大數量",
        "en_US": "greatest amount",
        "vi_VN": "số tiền lớn nhất"
    },
    "最小数量": {
        "zh_TW": "最小數量",
        "en_US": "minimum amount",
        "vi_VN": "số tiền tối thiểu"
    },
    "手续费百分比": {
        "zh_TW": "手續費百分比",
        "en_US": "Fee Percentage",
        "vi_VN": "Phần trăm phí"
    },
    "的百分比数字": {
        "zh_TW": "的百分比數字",
        "en_US": "percentage figures for",
        "vi_VN": "con số phần trăm cho"
    },
    "请使用数字表示": {
        "zh_TW": "請使用數字表示",
        "en_US": "Please use numbers",
        "vi_VN": "Vui lòng sử dụng số"
    },
    "手续费": {
        "zh_TW": "手續費",
        "en_US": "handling fee",
        "vi_VN": "phí xử lý"
    },
    "选单设定": {
        "zh_TW": "選單設定",
        "en_US": "menu settings",
        "vi_VN": "cài đặt trình đơn"
    },
    "电话区码": {
        "zh_TW": "電話區碼",
        "en_US": "phone area code",
        "vi_VN": "mã vùng điện thoại"
    },
    "银行名称": {
        "zh_TW": "銀行名稱",
        "en_US": "Bank name",
        "vi_VN": "tên ngân hàng"
    },
    "交易所名称": {
        "zh_TW": "交易所名稱",
        "en_US": "exchange name",
        "vi_VN": "trao đổi tên"
    },
    "转账统计": {
        "zh_TW": "轉賬統計",
        "en_US": "Transfer statistics",
        "vi_VN": "Thống kê chuyển nhượng"
    },
    "本月储值": {
        "zh_TW": "本月儲值",
        "en_US": "Top up this month",
        "vi_VN": "Nạp tiền trong tháng này"
    },
    "本月提领": {
        "zh_TW": "本月提領",
        "en_US": "Withdraw this month",
        "vi_VN": "Rút tiền trong tháng này"
    },
    "储值纪录": {
        "zh_TW": "儲值紀錄",
        "en_US": "stored value record",
        "vi_VN": "bản ghi giá trị được lưu trữ"
    },
    "储值时间": {
        "zh_TW": "儲值時間",
        "en_US": "Stored value time",
        "vi_VN": "Thời gian giá trị được lưu trữ"
    },
    "提领纪录": {
        "zh_TW": "提領紀錄",
        "en_US": "Withdrawal record",
        "vi_VN": "Hồ sơ rút tiền"
    },
    "申请时间": {
        "zh_TW": "申請時間",
        "en_US": "application time",
        "vi_VN": "thời gian nộp đơn"
    },
    "统计": {
        "zh_TW": "統計",
        "en_US": "statistics",
        "vi_VN": "số liệu thống kê"
    },
    "提领取消返还": {
        "zh_TW": "提領取消返還",
        "en_US": "Withdraw Cancellation Return",
        "vi_VN": "Rút tiền Hủy trả lại"
    },
    "结算": {
        "zh_TW": "結算",
        "en_US": "settlement",
        "vi_VN": "định cư"
    },
    "异动明细": {
        "zh_TW": "異動明細",
        "en_US": "Transaction details",
        "vi_VN": "Chi tiết giao dịch"
    },
    "异动查询": {
        "zh_TW": "異動查詢",
        "en_US": "Transaction query",
        "vi_VN": "truy vấn giao dịch"
    },
    "全部": {
        "zh_TW": "全部",
        "en_US": "all",
        "vi_VN": "tất cả"
    },
    "输入会员帐号": {
        "zh_TW": "輸入會員帳號",
        "en_US": "Enter member account",
        "vi_VN": "Nhập tài khoản thành viên"
    },
    "异动时间": {
        "zh_TW": "異動時間",
        "en_US": "Change time",
        "vi_VN": "Thay đổi thời gian"
    },
    "提领申请": {
        "zh_TW": "提領申請",
        "en_US": "Withdrawal application",
        "vi_VN": "đơn rút tiền"
    },
    "本月未处理": {
        "zh_TW": "本月未處理",
        "en_US": "Not processed this month",
        "vi_VN": "Không được xử lý trong tháng này"
    },
    "本月已送出": {
        "zh_TW": "本月已送出",
        "en_US": "Sent this month",
        "vi_VN": "Gửi trong tháng này"
    },
    "本月已取消": {
        "zh_TW": "本月已取消",
        "en_US": "Canceled for this month",
        "vi_VN": "Đã hủy trong tháng này"
    },
    "全选取": {
        "zh_TW": "全選取",
        "en_US": "select all",
        "vi_VN": "chọn tất cả"
    },
    "全取消": {
        "zh_TW": "全取消",
        "en_US": "cancel all",
        "vi_VN": "hủy bỏ tất cả"
    },
    "批次取消": {
        "zh_TW": "批次取消",
        "en_US": "batch cancel",
        "vi_VN": "hủy hàng loạt"
    },
    "帐号管理": {
        "zh_TW": "帳號管理",
        "en_US": "Account Management",
        "vi_VN": "Quản lý tài khoản"
    },
    "会员管理": {
        "zh_TW": "會員管理",
        "en_US": "Member Management",
        "vi_VN": "Quản lý thành viên"
    },
    "代理管理": {
        "zh_TW": "代理管理",
        "en_US": "Agent management",
        "vi_VN": "quản lý đại lý"
    },
    "银行审核": {
        "zh_TW": "銀行審核",
        "en_US": "bank audit",
        "vi_VN": "kiểm toán ngân hàng"
    },
    "子帐号管理": {
        "zh_TW": "子帳號管理",
        "en_US": "Sub-account management",
        "vi_VN": "Quản lý tài khoản phụ"
    },
    "权限设定": {
        "zh_TW": "權限設定",
        "en_US": "permission setting",
        "vi_VN": "cài đặt quyền"
    },
    "点数管理": {
        "zh_TW": "點數管理",
        "en_US": "point management",
        "vi_VN": "quản lý điểm"
    },
    "异动纪录": {
        "zh_TW": "異動紀錄",
        "en_US": "transaction record",
        "vi_VN": "ghi lại giao dịch"
    },
    "异动查询": {
        "zh_TW": "異動查詢",
        "en_US": "Transaction query",
        "vi_VN": "truy vấn giao dịch"
    },
    "提领列表": {
        "zh_TW": "提領列表",
        "en_US": "withdrawal list",
        "vi_VN": "danh sách rút tiền"
    },
    "异动统计": {
        "zh_TW": "異動統計",
        "en_US": "Transaction statistics",
        "vi_VN": "thống kê giao dịch"
    },
    "游戏管理": {
        "zh_TW": "遊戲管理",
        "en_US": "game management",
        "vi_VN": "quản lý trò chơi"
    },
    "游戏控端": {
        "zh_TW": "遊戲控端",
        "en_US": "game console",
        "vi_VN": "bảng điều khiển trò chơi"
    },
    "盈亏统计": {
        "zh_TW": "盈虧統計",
        "en_US": "Profit and loss statistics",
        "vi_VN": "Thống kê lãi lỗ"
    },
    "即时注单": {
        "zh_TW": "即時注單",
        "en_US": "Instant Bet",
        "vi_VN": "Đặt cược tức thì"
    },
    "金流管理": {
        "zh_TW": "金流管理",
        "en_US": "cash flow management",
        "vi_VN": "quản lý dòng tiền"
    },
    "金流列表": {
        "zh_TW": "金流列表",
        "en_US": "Cash flow list",
        "vi_VN": "Danh mục dòng tiền"
    },
    "储值纪录": {
        "zh_TW": "儲值紀錄",
        "en_US": "stored value record",
        "vi_VN": "bản ghi giá trị được lưu trữ"
    },
    "私讯管理": {
        "zh_TW": "私訊管理",
        "en_US": "private message management",
        "vi_VN": "quản lý tin nhắn riêng tư"
    },
    "私讯列表": {
        "zh_TW": "私訊列表",
        "en_US": "private message list",
        "vi_VN": "danh sách tin nhắn riêng tư"
    },
    "内容管理": {
        "zh_TW": "内容管理",
        "en_US": "content management",
        "vi_VN": "quản lý nội dung"
    },
    "说明设定": {
        "zh_TW": "説明設定",
        "en_US": "description setting",
        "vi_VN": "cài đặt mô tả"
    },
    "活动设定": {
        "zh_TW": "活動設定",
        "en_US": "Activity settings",
        "vi_VN": "Cài đặt hoạt động"
    },
    "网站公告": {
        "zh_TW": "網站公告",
        "en_US": "Website Announcement",
        "vi_VN": "Thông báo trang web"
    },
    "橫幅管理": {
        "zh_TW": "橫幅管理",
        "en_US": "Banner management",
        "vi_VN": "quản lý biểu ngữ"
    },
    "横幅设定": {
        "zh_TW": "橫幅設定",
        "en_US": "Banner settings",
        "vi_VN": "Cài đặt biểu ngữ"
    },
    "系统设定": {
        "zh_TW": "系統設定",
        "en_US": "system program",
        "vi_VN": "chương trình hệ thống"
    },
    "基本设定": {
        "zh_TW": "基本設定",
        "en_US": "basic settings",
        "vi_VN": "cài đặt cơ bản"
    },
    "网站设定": {
        "zh_TW": "網站設定",
        "en_US": "website settings",
        "vi_VN": "cài đặt trang web"
    },
    "回合管理": {
        "zh_TW": "回合管理",
        "en_US": "turn management",
        "vi_VN": "quản lý lần lượt"
    },
    "游戏设定": {
        "zh_TW": "遊戲設定",
        "en_US": "game setting",
        "vi_VN": "Thiết lập trò chơi"
    },
    "开奖结果": {
        "zh_TW": "開獎結果",
        "en_US": "lottery result",
        "vi_VN": "kết quả xổ số"
    },
    "选择期权": {
        "zh_TW": "选择期權",
        "en_US": "option option",
        "vi_VN": "tùy chọn tùy chọn"
    },
    "BOSS游戏": {
        "zh_TW": "BOSS遊戲",
        "en_US": "boss game",
        "vi_VN": "trò chơi ông chủ"
    },
    "玩法设定": {
        "zh_TW": "玩法設定",
        "en_US": "Game settings",
        "vi_VN": "Cài đặt trò chơi"
    },
    "活动纪录": {
        "zh_TW": "活動紀錄",
        "en_US": "Activity record",
        "vi_VN": "Bản ghi hoạt động"
    },
    "盈亏查询": {
        "zh_TW": "盈虧查詢",
        "en_US": "Profit and loss inquiry",
        "vi_VN": "Truy vấn lãi lỗ"
    },
    "橫幅管理": {
        "zh_TW": "盈虧查詢",
        "en_US": "Banner management",
        "vi_VN": "Quản lý biểu ngữ"
    },
    "域名中心": {
        "zh_TW": "域名中心",
        "en_US": "Domain Name Center",
        "vi_VN": "Trung tâm tên miền"
    },
    "域名管理": {
        "zh_TW": "域名管理",
        "en_US": "domain name management",
        "vi_VN": "quản lý tên miền"
    },
    "访问纪录": {
        "zh_TW": "訪問紀錄",
        "en_US": "access records",
        "vi_VN": "lịch sử truy cập"
    },
    "域名": {
        "zh_TW": "域名",
        "en_US": "domain name",
        "vi_VN": "tên miền"
    },
    "添加时间": {
        "zh_TW": "添加時間",
        "en_US": "add time",
        "vi_VN": "thêm thời gian"
    },
    "共计访问次数": {
        "zh_TW": "共計訪問次數",
        "en_US": "total visits",
        "vi_VN": "tổng số lượt truy cập"
    },
    "访问失败次数": {
        "zh_TW": "訪問失敗次數",
        "en_US": "Access failures",
        "vi_VN": "Lỗi truy cập"
    },
    "失效时间": {
        "zh_TW": "失效時間",
        "en_US": "Expiration time",
        "vi_VN": "Thời gian hết hạn"
    },
    "正常": {
        "zh_TW": "正常",
        "en_US": "normal",
        "vi_VN": "Bình thường"
    },
    "已失效": {
        "zh_TW": "已失效",
        "en_US": "expired",
        "vi_VN": "hết hạn"
    },
    "访问时间": {
        "zh_TW": "訪問時間",
        "en_US": "interview time",
        "vi_VN": "thời gian phỏng vấn"
    },
    "访问状态": {
        "zh_TW": "訪問狀態",
        "en_US": "access status",
        "vi_VN": "trạng thái truy cập"
    },
    "域名编辑": {
        "zh_TW": "域名編輯",
        "en_US": "Domain Editing",
        "vi_VN": "Chỉnh sửa tên miền"
    },
    "请输入二级域名": {
        "zh_TW": "請輸入二級域名",
        "en_US": "Please enter the second-level domain name",
        "vi_VN": "Vui lòng nhập tên miền cấp 2",
    },
    "验证设定": {
        "zh_TW": "驗證設定",
        "en_US": "authentication settings",
        "vi_VN": "cài đặt xác thực",
    },
    "转帐设定": {
        "zh_TW": "轉帳設定",
        "en_US": "Transfer settings",
        "vi_VN": "Cài đặt chuyển",
    },
    "验证纪录": {
        "zh_TW": "驗證紀錄",
        "en_US": "verification record",
        "vi_VN": "hồ sơ xác minh",
    },
    "接收地址": {
        "zh_TW": "接收地址",
        "en_US": "receiving address",
        "vi_VN": "địa chỉ nhận",
    },
    "邮箱": {
        "zh_TW": "邮箱",
        "en_US": "Email",
        "vi_VN": "Thư",
    },
    "验证码":{
        "zh_TW": "驗證碼",
        "en_US": "Verification code",
        "vi_VN": "Mã xác nhận",
    }

};


export default lang;


// WEBPACK FOOTER //
// ./src/utils/i18n.js